const getMuralSlug = (mural) => {
  const artistSlug = mural.override_artist_slug ? mural.override_artist_slug : mural.artists.map((artist) => artist.mural_artists_id.slug).join('-and-');
  console.log(artistSlug);
  return `${mural.slug}-by-${artistSlug}`;
};

module.exports.getMuralSlug = getMuralSlug;